// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_i5-0";
export var actionModalContentContainer = "_i5-1";
export var createTagButton = "_i5-2";
export var footerContainer = "_i5-7";
export var fullWidthDivider = "_i5-3";
export var hasCreateTagButton = "_i5-4";
export var noCreateTagButton = "_i5-5";
export var tagsContainer = "_i5-6";
export var tagsModalContentContainer = "_i5-8";